
import md5 from './md5';

export const BASE_IMAGE_URL = 'https://dhn2zyrxn8g9b.cloudfront.net/remote.axd?';

export const MD5 = md5;

/* eslint-disable */
export function distance(lat1, lon1, lat2, lon2, unit) {
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  } else {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344
    }
    if (unit == "N") {
      dist = dist * 0.8684
    }
    return dist;
  }
}
/* eslint-enable */

export function getCustomSelectStyles(overrides = { option: {}, control: {} }) {
  return {
    option: (styles, state) => {
      const backgroundColor = state.isSelected ? '#db011c' : styles.backgroundColor;
      return {
        ...styles,
        backgroundColor,
        textAlign: 'left',
        ...overrides.option,
      };
    },
    control: styles => ({
      ...styles,
      padding: '5px 8px',
      fontSize: '16px',
      borderRadius: '0px',
      border: '1px solid black !important',
      outline: 'none !important',
      boxShadow: 'none !important',
      ...overrides.control,
      textTransform: 'uppercase',
    }),
  };
}

export function getCached(key) {
  try {
    const json = sessionStorage.getItem(key);
    if (json === '' || json === null || json === undefined) {
      return null;
    }
    return JSON.parse(json);
  } catch (error) {
    console.log('sessionstorage not supported');
    return null;
  }
}

export function setCached(key, object) {
  if (object === {}) {
    return;
  }

  try {
    const json = JSON.stringify(object);
    sessionStorage.setItem(key, json);
  } catch (error) {
    console.log('sessionstorage not supported');
  }
}

export function clearCache(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.log('sessionstorage not supported');
  }
}

export function getRequestSettings(method, params = {}) {
  const request = {
    method,
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      Accept: 'application/json',
    },
  };

  if (method === 'POST') {
    request.body = JSON.stringify(params);
  }

  return request;
}

export function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie(cname, cvalue, expiry = null) {
  if (expiry) {
    const expires = `expires=${expiry.toUTCString()}`;
    document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
  } else {
    document.cookie = `${cname}=${cvalue}; path=/`;
  }
}

export function generateRandomString(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}
